"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_intl_1 = require("react-intl");
var FormField_1 = __importDefault(require("../FormField"));
var Label_1 = __importDefault(require("../Label"));
var FieldError_1 = __importStar(require("../FieldError"));
var Select_1 = __importDefault(require("../Select"));
var StyledField = styled_components_1["default"](Select_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), FieldError_1.error);
var SelectField = function (_a) {
    var id = _a.id, label = _a.label, options = _a.options, blank = _a.blank, input = _a.input, meta = _a.meta, disabled = _a.disabled, errorMessage = _a.errorMessage;
    var hasError = meta.touched && meta.error;
    var errorValue = errorMessage || meta.error || meta.submitError;
    return (react_1["default"].createElement(FormField_1["default"], null,
        label ? react_1["default"].createElement(Label_1["default"], null, label) : null,
        react_1["default"].createElement(StyledField, __assign({ id: id }, input, { error: hasError, disabled: disabled }),
            blank ? react_1["default"].createElement("option", { value: "" }) : null,
            options.map(function (option) { return (react_1["default"].createElement("option", { key: option.name, value: option.value }, option.name)); })),
        hasError ? (react_1["default"].createElement(FieldError_1["default"], null, errorValue.id ? (react_1["default"].createElement(react_intl_1.FormattedMessage, { id: errorValue.id, values: __assign({}, errorValue.values) })) : (errorValue))) : null));
};
exports["default"] = SelectField;
var templateObject_1;
//# sourceMappingURL=SelectField.js.map